module.exports = __webpack_public_path__ + "6619ed79eddcb52db60f22c330f95f1f.ttf";